import { Head } from '@inertiajs/react'
import QuestionMarkIcon from '@mui/icons-material/QuestionMarkRounded'
import useIntl from '@/lib/hooks/useIntl'
import PageErrorFallback from '@/components/PageErrorFallback'

export const Error404 = () => {
  const t = useIntl('views.error_page.404')

  return (
    <>
      <Head title={t('.title')} />
      <PageErrorFallback
        title={t('.title')}
        description={t('.description')}
        slots={{
          icon: QuestionMarkIcon,
        }}
        slotProps={{
          icon: {
            sx: {
              p: 0.75,
              fontSize: 64,
              color: 'warning.main',
              border: '5px solid',
              borderColor: 'warning.main',
              borderRadius: '50%',
            },
          },
        }}
      />
    </>
  )
}
